<template>
  <v-container fill-height fluid grid-list-xl>
    <v-flex>
      <app-upsert
        title="New Lost"
        :config="config"
        :item="lost"
        :api-upsert="apiSave"
        @saved="saved"
      />
    </v-flex>
  </v-container>
</template>

<script>
import config from "./config_new.js";
import request from "@/utils/request";

export default {
  name: "LostNew",

  data({ $store }) {
    // type_id e _url_error devono essere presenti nell'oggetto iniziale
    // affinché Vue 2 li renda reattivi (la mutation dal blur handler li aggiornerà).
    let lost = { type_id: null, _url_error: null };
    if ($store.getters.user.site_id) {
      lost.site_id = $store.getters.user.site_id;
    }
    if ($store.getters.app.protocol && $store.getters.app.protocol.id !== -1) {
      lost.protocol_id = $store.getters.app.protocol.id;
    }
    return { config, lost };
  },

  methods: {
    /**
     * Invia il form come multipart/form-data in modo che il file venga
     * caricato correttamente. I campi interni (prefisso _) vengono esclusi.
     * axios imposta automaticamente Content-Type: multipart/form-data
     * quando riceve un oggetto FormData.
     */
    apiSave(entityName, item) {
      const formData = new FormData();
      for (const [key, value] of Object.entries(item)) {
        // Salta campi interni/transitori
        if (key.startsWith("_")) continue;
        if (value === null || value === undefined) continue;
        formData.append(key, value);
      }
      return request({ url: "/lost", method: "post", data: formData });
    },

    saved({ data }) {
      this.$router.push(`/lost/${data.id}`);
    },
  },
};
</script>
